var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"sheet-price",class:[_vm.alignmentClassName]},[_vm._v(" "+_vm._s(_vm.displayPrice)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }